<template>
  <div>NotFound</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({});
</script>
